import React from 'react'
import PropTypes from 'prop-types'
import { IonTextarea } from '@ionic/react'
import { generateInputErrorId } from 'utils'
import InputError from 'components/formik/InputError'

// Shared required textarea used by the accept-decline section partials
// (tech comments, reschedule reason, decline reason). Keeps the
// section-specific markup/styling consistent across the manager forms.
function SectionTextarea({
  id,
  name,
  label,
  value,
  error,
  touched,
  setFieldValue,
  setFieldTouched,
  required = true,
}) {
  return (
    <div className="accept-decline-section__field">
      <label className="accept-decline-section__label" htmlFor={id}>
        {required && (
          <span className="required-indicator" aria-hidden="true">
            *
          </span>
        )}
        {label}
      </label>
      <IonTextarea
        id={id}
        name={name}
        className="accept-decline-section__input-native accept-decline-section__textarea"
        value={value}
        onIonChange={(e) => setFieldValue(name, e.detail.value ?? '')}
        onIonBlur={() => setFieldTouched(name, true)}
        rows={4}
        aria-describedby={
          error && touched ? generateInputErrorId(name) : undefined
        }
      />
      <InputError
        name={name}
        invalid={Boolean(error)}
        error={error}
        touched={touched}
      />
    </div>
  )
}

SectionTextarea.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  value: PropTypes.string,
  error: PropTypes.string,
  touched: PropTypes.bool,
  setFieldValue: PropTypes.func.isRequired,
  setFieldTouched: PropTypes.func.isRequired,
  required: PropTypes.bool,
}

export default SectionTextarea
